module.exports = __webpack_public_path__ + "img/int-paper-logo.d5671b52.jpg";